import React from 'react'
import { Route, withRouter } from 'react-router-dom'
import Default from '../../layouts/default'

const render = (Component, Layout = Default) => props => (
  <Layout {...props}>
    <Component />
  </Layout>
)

const Public = ({ component, layout, ...rest }) => (
  <Route {...rest} render={render(component, layout)} />
)

export default withRouter(Public)



// WEBPACK FOOTER //
// ./src/containers/routes/public/index.js